import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ExportCsvResponse } from 'src/app/models/exportCsvResponst';
import { toggleStatusValue } from 'src/app/models/toggleStatusValue';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class manageAreaService {
  constructor(private http: HttpClient) {}

  getAreaList(data: string): Observable<any> {
    return this.http
      .get<{
        data: any;
      }>(`${environment.base_url}area?${data}`)
      .pipe(map(res => res.data));
  }

  addArea(data: any): Observable<any> {
    return this.http
      .post<{ data: any }>(`${environment.base_url}area`, data)
      .pipe(map(res => res.data));
  }

  getAreaById(id: string | null): Observable<any> {
    return this.http
      .get<{ data: any }>(`${environment.base_url}area/${id}`)
      .pipe(map(res => res.data));
  }

  updateAreaManager(
    data: any | { isBlocked: boolean },
    id: string | null
  ): Observable<any> {
    return this.http
      .put<{
        data: any;
      }>(`${environment.base_url}area/${id}`, data)
      .pipe(map(res => res.data));
  }

  deleteArea(id: string): Observable<number> {
    return this.http
      .delete<{
        statusCode: number;
      }>(`${environment.base_url}area/${id}`)
      .pipe(map(res => res.statusCode));
  }

  handleVendorStatus(data: toggleStatusValue, id: string): Observable<any> {
    return this.http
      .put<{
        data: any;
      }>(`${environment.base_url}approveVendor/${id}`, data)
      .pipe(map(res => res.data));
  }

  exportCsv(query: string): Observable<ExportCsvResponse> {
    return this.http.get<ExportCsvResponse>(
      `${environment.base_url}vendorExport?${query}`
    );
  }

  getAreaListing(id: string | undefined): Observable<any> {
    return this.http.get<any>(`${environment.base_url}areaDropDown/${id}`);
  }

  assignArea(data: any, salesManagerId: string | undefined): Observable<any> {
    return this.http.post<any>(
      `${environment.base_url}assignArea/${salesManagerId}`,
      data
    );
  }

  getAreaPathTaken(employeeId: string | null, body: any): Observable<any> {
    return this.http
      .post<any>(
        `${environment.base_url}trackDetailsSubSalesManager/${employeeId}`,
        body
      )
      .pipe(map(res => res.data));
  }
}
